module.exports = __webpack_public_path__ + "0362c45f92e760460b4d02d3d43ad9ad.svg";